export function loadImage(path) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
            resolve(img);
        };
        img.src = path;
    });
}
export function scaleImageBitmapToDataUrl(imageBitmap, width, height) {
    const newCanvas = document.createElement('canvas');
    newCanvas.width = width;
    newCanvas.height = height;
    const ctx = newCanvas.getContext('2d');
    if (!ctx) {
        throw new Error('Could not get canvas context to scale image bitmap');
    }
    ctx.drawImage(imageBitmap, 0, 0, width, height);
    return ctx.canvas.toDataURL();
}
export function convertImageBitmapToDataUrl(imageBitmap) {
    const canvas = document.createElement('canvas');
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('Could not get canvas context to convert image bitmap to data URL');
    }
    ctx.drawImage(imageBitmap, 0, 0);
    return canvas.toDataURL();
}
export async function fetchToImageBitmap(imageUrl) {
    try {
        const response = await fetch(imageUrl);
        if (!response.ok) {
            return;
        }
        const blob = await response.blob();
        return createImageBitmap(blob);
    }
    catch {
        // return undefined
    }
}
